import Moment from "moment-timezone";
import { extendMoment } from "moment-range";
Moment.tz.setDefault("Europe/Athens");

const moment = extendMoment(Moment);
const momentRange = moment;

export { moment, momentRange };
